module.exports = __webpack_public_path__ + "/assets/tw.png";


/*****************
 ** WEBPACK FOOTER
 ** ../src/dash/front/styles/images/tw.png
 ** module id = 1061
 ** module chunks = 0
 **/